import { RootState } from '../../store';
import { PhyDevice } from './types';
import { deviceSelectors, sliceName } from './state';

export const selectDevices = (state: RootState): PhyDevice[] => deviceSelectors.selectAll(state[sliceName].devices);
export const selectDeviceById =
  (deviceId: string) =>
  (state: RootState): PhyDevice | undefined =>
    deviceSelectors.selectById(state[sliceName].devices, deviceId);
